import { RequestError } from './request_errors';

export class HttpError extends RequestError {
  constructor(message: string, status: number = 500, details?: Record<string, unknown>) {
    super(message, status, details);
  }
}
